import React from 'react';
import config from 'config';
import PropTypes from 'prop-types';

const LiveSummary = (props) => {

	/*function optionClicked(node) {
		props.click(node);
	}*/
	function listAreas(root, type, res) {

		if (root) {
			if (root.type == type.code) {
				res.push(root);
			}
			if (root.children) {
				root.children.forEach((child) => {
					if (child.type == type.code) {
						res.push(child);
					}
				})
			}
		}
	}

	function summary(node) {
		var res = {
			total: 0,
			inUse: 0
		}
		node.children.forEach((child) => {
			if (child.type == "sensor") {
				var ss = props.sensorMap.get(child.id);
				if (typeof ss != "undefined") {
					res.total++;
					if (ss.inuse) {
						res.inUse++;
					}
				}
			}
		});
		return res;
	}

	var OAs = [], MRs = [];
	listAreas(props.root, config.room.OPENAREA, OAs);
	listAreas(props.root, config.room.MEETINGROOM, MRs);

	return (
		<div className="live-stats-card">
			<table className="table text-center">
				<tbody>
					<tr>
						<td></td>
						<td className="live-stats-heading">Capacity:</td>
						<td className="live-stats-heading" colSpan="3">Current Usage:</td>
					</tr>
					{
						(OAs.length > 0) ? ([
							<tr className="objects-list" key="OAs">
								<td className="live-stats-heading">Open Areas </td>
								<td> </td>
								<td>In Use</td>
								<td>Unused</td>
								<td>Occupancy</td>
							</tr>,
							OAs.map((x) => {
								var smr = summary(x);
								return (
									<tr className="objects-list" key={x.id}>
										<td className="object-name">{x.info.name}</td>
										<td>{smr.total}</td>
										<td>{smr.inUse}</td>
										<td>{smr.total - smr.inUse}</td>
										<td>{(smr.total > 0) ? Math.round(100 * smr.inUse / smr.total) : 0}%</td>
									</tr>
								);
							})
						]) : ([])
					}
					{
						(MRs.length > 0) ? ([
							<tr className="objects-list" key="MRs">
								<td className="live-stats-heading">Meeting Rooms</td>
								<td> </td>
								<td>Status</td>
								<td>Users</td>
								<td>Efficiency</td>
							</tr>,
							MRs.map((x) => {
								var smr = summary(x);
								return (
									<tr className="objects-list" key={x.id}>
										<td className="object-name">{x.info.name}</td>
										<td>{smr.total}</td>
										<td><Status taken={(smr.inUse > 0)} /></td>
										<td>{smr.inUse}</td>
										<td>{(smr.inUse > 0) ? Math.round(100 * smr.inUse / smr.total) + "%" : "--"}</td>
									</tr>
								);
							})
						]) : ([])
					}
				</tbody>
			</table>
		</div>
	);
}
LiveSummary.propTypes = {
	root: PropTypes.object.isRequired,
	sensorMap: PropTypes.object.isRequired
}
export default LiveSummary;
const Status = (props) => {
	if (props.taken) {
		return (<img src="/src/assets/icons/point-red.svg" alt="Taken" data-tooltip="Taken" />);
	} else {
		return (<img src="/src/assets/icons/point-green.svg" alt="Free" data-tooltip="Available" />);
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/live/summary.jsx